$(window).scroll(function() {
  if ($(window).scrollTop() >= 148) {
    $("header.header").addClass("header-new-set");
  } else {
    $("header.header").removeClass("header-new-set");
  }
});

$(document).ready(function() {
  $(".inner-tab-head-main").first().addClass("active");
  $(".index-based-sec").first().addClass("active");
  $(".drawerxx").removeClass("active-drawer");
  $(".drawerxx").first().addClass("active-drawer");
  $(".inner-tab-head-main").click(function() {
    $(".inner-tab-head-main").removeClass("active");
    $(".index-based-sec").removeClass("active");
    $(this).addClass("active");
    var index = $(this).index(".inner-tab-head-main");
    $(".index-based-sec").eq(index).addClass("active");
    $(".drawerxx").removeClass("active-drawer");
    $(".index-based-sec").eq(index).find(".drawerxx").addClass("active-drawer");
  });
});



function dshow() {
    $(".drawerclosexx").show()
    $(".drawerxx").each(function() {
        $(this).css("transform", "translateX(0%)");
    });
}

function dhide() {
    $(".drawerclosexx").hide()
    $(".drawerxx").each(function() {
        $(this).css("transition", "all ease-in 0.3s");
        $(this).css("transform", "translateX(100%)");
    });
}

  
$(function() {
  var hieghtThreshold = $(".ag-12c").offset().top;
  var hieghtThreshold_end  = $(".ag-12c").offset().top +$(".ag-12c").height() ;
  $(window).scroll(function() {
      var scroll = $(window).scrollTop();

      if (scroll >= hieghtThreshold && scroll <=  hieghtThreshold_end ) {
          $(".ag-12i.ag-12k").eq(0).addClass("active-parallax");
      } else {
          $(".ag-12i.ag-12k").eq(0).removeClass("active-parallax");
      }
  });
})
$(document).ready(function() {
  let observerOptions = {
      root: null, // use the viewport as the root
      rootMargin: '0px',
      threshold: 0.5
  };

  let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
          if (entry.isIntersecting) {
              $('.ag-12i.ag-12k').removeClass('active-parallax');
              $(entry.target).addClass('active-parallax');
          }
      });
  }, observerOptions);

  $('.ag-12i.ag-12k').each(function() {
      observer.observe(this);
  });
});

$(document).ready(function () {
  $('.answer').hide();
  $('.question').click(function () {
    var a = $(this).parent('li').find('.answer');
    if (a.css('display') == 'none') {
      $('.question').removeClass('active');
      $('.answer').slideUp('fast');
      a.slideDown();
      $(this).addClass('active');
    } else {
      a.slideUp();
      $(this).removeClass('active');
    }
  });
});
// 
$(".inner-boxed").click(function () {
  let getindexnw = $(this).index(".inner-boxed");
  let elmentindexnew = $(".first-section").eq(getindexnw);
  $('html, body').animate({
      scrollTop: elmentindexnew.offset().top
  }, 1000);

  $(".inner-boxed").removeClass("highlightx");
  $(this).addClass("highlightx");
});
$(window).scroll(function() {
  let scrollPosition = $(this).scrollTop();

  $(".first-section").each(function(index) {
      let sectionTop = $(this).offset().top;
      let sectionHeight = $(this).outerHeight();

      if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
          // Remove highlight class from all inner-boxed elements
          $(".inner-boxed").removeClass("highlightx");
          // Add highlight class to the corresponding inner-boxed element
          $(".inner-boxed").eq(index).addClass("highlightx");

          // Remove highlight class from all sections
          $(".first-section").removeClass("highlightx");
          // Add highlight class to the current section
          $(this).addClass("highlightx");
      }
  });
});


// 
// $(document).ready(function(){
//   $(".popup-trial-stop").click(function(){
//       $(this).closest(".popup-trial-bg").hide();
//   });

//   $(".popup-trial-play").click(function(){
//       $(this).closest(".popup-trial-bg").show();
//   });
// });